<template>
  <div v-if="borrow">
    <ApplicantInformation
      :client="borrow"
      :route-back-to-list="{
        name: 'list-applicant'
      }"
    >
      <div>
        <div class="col-md-12">
          <x-box
            :title="$t('string.commentList')"
            tool
          >
            <template slot="box-tools">
              <button
                class="btn btn-default btn-sm mr-2"
                @click="onRefreshCommentList"
              >
                <i class="fa fa-refresh" /> {{ $t('string.refresh') }}
              </button>
              <button
                class="btn btn-primary btn-sm"
                v-if="can([$Permissions.backend.comment.store])"
                data-toggle="modal"
                @click="onAddNewComment"
                data-target="#createCommentModal"
              >
                {{ $t('string.addComment') }}
              </button>
            </template>
            <comment-list :borrow-id="parseInt($route.params.borrow_id)" />
          </x-box>
          <create-comment-modal :borrow-id="parseInt($route.params.borrow_id)" />
          <edit-comment-modal />
        </div>
      </div>
    </ApplicantInformation>
  </div>
</template>

<script>
import CommentList from '@/views/comments/components/CommentList'
import CreateCommentModal from '@/views/comments/components/CreateCommentModal'
import EditCommentModal from '@/views/comments/components/EditCommentModal'
import ApplicantInformation from '@/components/ApplicantInformation'

export default {
  name: 'Show',
  metaInfo () {
    return {
      title: this.$t('menu.showApplicant'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: {
    ApplicantInformation,
    EditCommentModal,
    CreateCommentModal,
    CommentList
  },
  data () {
    return {
      borrow: null
    }
  },
  methods: {
    getBorrow () {
      this.$isLoading(true)
      this.$axios.post(this.$base_api + '/api/v4/backend/borrow/show', {
        borrow_id: this.$route.params.borrow_id
      }).then(({ data }) => {
        if (data.data) {
          this.borrow = data.data
        } else {
          this.borrow = null
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    onRefreshCommentList () {
      this.$store.commit('comment/setBorrowId', parseInt(this.$route.params.borrow_id))
      this.$store.commit('comment/setRefreshCommentList')
    },
    onAddNewComment () {
      this.$store.commit('comment/setBorrowId', parseInt(this.$route.params.borrow_id))
    }
  },
  mounted () {
    this.getBorrow()
  }
}
</script>

<style scoped>

</style>
